import React, { useEffect, useRef, useState } from "react";

import useTranslation from "next-translate/useTranslation";
import styles from "./styles/Lobby.module.css";
import LobbyPopups from "./popups/LobbyPopups";
import Head from "next/head";
import {
  useLobby,
  enterLobby,
  // exitLobby,
  showChallengePopup,
  chooseGame,
  setTab,
} from "../../redux/lobby";
import {
  ChessSets,
  CREATE_GAME_TAB,
  DAILY_GAMES_TAB,
  DAILY_TAB,
  LIVE_GAME_TAB,
  // CREATE_GAME_TAB,
  // DAILY_TAB,
  // LIVE_GAME_TAB,
  ModeIds,
  TimeControl,
  VARIANT_CHESS,
} from "@chesshotel/constants";
import { getModeId } from "../../util/util";
// import {  } from "../ducks/lobby";
import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
// import { getModeId } from "../../util/util";
import LobbyBody from "./LobbyBody";
import PlayWire from "../../components/common/play-wire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_GAM,
  ADS_PROVIDER_ADSENSE,
  useSiteData,
} from "../../redux/siteData";
import { useMembership } from "../../redux/membership";
import AdSense from "../../components/common/ad-sense";
import { useRouter } from "next/router";
import ChallengePopup from "../challenge/ChallengePopup";
import CustomGamePopup from "./popups/CustomGamePopup";
import LobbyHead from "./LobbyHead";
import CreateGame from "./CreateGame";
import { setSetting, useSettings } from "@/redux/settings";
import {
  preloadChessImages,
  getPieceImageUrls,
} from "../../util/imagePreloader";
import boardStyles from "../../chessBoard/components/Board.module.css";
import { useSignIn } from "@/redux/signIn";
import { useWsConnection } from "@/redux/wsConnection";
import ChessSetPopup from "./popups/ChessSetPopup";
import { shouldCountPlaywirePageview } from "@/lib/playwire";
import {
  createLobbyPlaywireAdController,
  getLobbyAdLayout,
  hasLobbySideAd,
  type LobbyAdLayout,
} from "./playwireLobbyAds";

function initLobbyChosenGame(isDesktop: boolean, tab: number) {
  try {
    const timeVal = localStorage.getItem("chosenTime");
    const incVal = localStorage.getItem("chosenInc");
    const variantVal = localStorage.getItem("chosenVariant");
    const turnLengthVal = localStorage.getItem("turnLength");
    const timeControlVal = localStorage.getItem("timeControl");

    const time = timeVal ? parseInt(timeVal) : 10;
    const inc = incVal ? parseInt(incVal) : 0;
    const variant = variantVal ? parseInt(variantVal) : VARIANT_CHESS;
    const timeControl = timeControlVal
      ? parseInt(timeControlVal)
      : TimeControl.LIVE;
    const turnLength = turnLengthVal ? parseInt(turnLengthVal) : 2;

    if (timeControl == TimeControl.LIVE) {
      if (typeof window !== "undefined") {
        if (tab !== DAILY_GAMES_TAB) {
          if (isDesktop) {
            setTab(LIVE_GAME_TAB);
          } else {
            setTab(CREATE_GAME_TAB);
          }
        }
      }
    }

    chooseGame({
      time,
      inc,
      variant,
      modeId: getModeId(time, variant, timeControl),
      turnLength,
      timeControl,
    });
  } catch (e) {
    chooseGame({
      time: 10,
      inc: 0,
      variant: VARIANT_CHESS,
      modeId: ModeIds.RAPID,
      timeControl: TimeControl.LIVE,
      turnLength: 2,
    });
  }
}

function DevelopmentAd({ adLayout }: { adLayout: LobbyAdLayout }) {
  const size =
    adLayout === "railWide"
      ? "300 × 600"
      : adLayout === "railNarrow"
        ? "160 × 600"
        : "Responsive × 100";

  return (
    <div
      className={`${styles.fakeAd} ${
        adLayout === "bottom" ? styles.fakeBottomAd : ""
      }`}
      aria-label={`Development ad preview, ${size}`}
    >
      <span className={styles.fakeAdEyebrow}>Ad preview</span>
      <span>{size}</span>
    </div>
  );
}

const GAM_SIZE_RAIL_NARROW = [[160, 600]];
const GAM_SIZE_RAIL_WIDE = [[300, 600]];
const GAM_SIZE_MOBILE = [[320, 100]];

let GAM_SLOT_DESKTOP = "/22528994871/ch_lobby_right_rail";
let GAM_SLOT_MOBILE = "/22528994871/ch_lobby_mobile_bottom";
let GAM_ID_DESKTOP = "div-ch_lobby_right_rail";
let GAM_ID_MOBILE = "div-ch_lobby_mobile_bottom";

function initGAM(slotRef: any, adLayout: LobbyAdLayout) {
  if (!window.googletag?.cmd) return;

  let GAM_SLOT = GAM_SLOT_MOBILE;
  let GAM_ID = GAM_ID_MOBILE;
  let GAM_SIZE = GAM_SIZE_MOBILE;

  if (hasLobbySideAd(adLayout)) {
    GAM_SLOT = GAM_SLOT_DESKTOP;
    GAM_ID = GAM_ID_DESKTOP;
    GAM_SIZE =
      adLayout === "railWide" ? GAM_SIZE_RAIL_WIDE : GAM_SIZE_RAIL_NARROW;
  }

  window.googletag.cmd.push(() => {
    const slot = window.googletag
      .defineSlot(GAM_SLOT, GAM_SIZE, GAM_ID)
      ?.addService(window.googletag.pubads());

    if (!slot) return;
    slotRef.current = slot;

    window.googletag.display(GAM_ID);
  });
}

function initYandex(adLayout: LobbyAdLayout) {
  // window.yaContextCb.push(() => {
  //   window.Ya.Context.AdvManager.render({
  //     renderTo: "yandex_rtb_R-A-1674804-8",
  //     blockId: "R-A-1674804-8",
  //   });
  // });

  if (hasLobbySideAd(adLayout)) {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-5",
        blockId: "R-A-1674804-5",
      });
    });
  } else {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-9",
        blockId: "R-A-1674804-7",
      });
    });
  }
}

function preloadStockfish() {
  const preloadQuick = async () => {
    // Preload the Stockfish worker early so end-of-game quick pass is instant
    try {
      const mod = await import("@/modules/gameReview/stockfishPool");
      // Preload only a single worker on first load; GameReviewStart will expand the pool.
      await mod.initStockfishPool(true, 1, true);
    } catch (e) {}
    // Optionally also preload the quick client review module
    try {
      await import("@/modules/gameReview/quickClientReview");
    } catch (e) {}
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(preloadQuick);
  } else {
    setTimeout(preloadQuick, 5000);
  }
}
/**
 * Checks if user is a returning visitor by looking for saved game settings.
 * First-time visitors get the new chess set by default.
 * Returning visitors who haven't seen the popup will see it.
 */
function checkChessSetForUser(): { showPopup: boolean } {
  const hasSeenPopup = localStorage.getItem("chessSetPopupSeen") === "true";
  if (hasSeenPopup) {
    return { showPopup: false };
  }

  // Check if user has any saved game settings (indicating they're a returning user)
  const savedSettings = [
    "chosenTime",
    "chosenInc",
    "chosenVariant",
    "turnLength",
    "timeControl",
  ];
  const isReturningUser = savedSettings.some(
    (key) => localStorage.getItem(key) !== null,
  );

  const currentChessSet = localStorage.getItem("chessSet");
  if (currentChessSet === ChessSets.STAUNTY) {
    return { showPopup: false };
  }

  if (isReturningUser) {
    // Returning user who hasn't seen popup - show it

    return { showPopup: true };
  } else {
    // First-time visitor - set new chess set as default
    setSetting({ name: "chessSet", val: ChessSets.CHESSHOTEL_NEW });
    localStorage.setItem("chessSetPopupSeen", "true");
    return { showPopup: false };
  }
}

export default function Lobby() {
  const { t } = useTranslation("common");

  const { customGamePopupVisible, challengePopupVisible, tab } = useLobby();
  const { adsVisible, adsProvider } = useSiteData();
  const { tier } = useMembership();
  // const { loading } = useSignIn();
  // const { wsConnected } = useWsConnection();
  // const { memberLoggedIn } = useUser();
  const { chessSet } = useSettings();
  const [isDesktop, setIsDesktop] = useState<boolean | null>(null);
  const [showChessSetPopup, setShowChessSetPopup] = useState(false);
  const [adLayout, setAdLayout] = useState<LobbyAdLayout | null>(null);
  const showDevelopmentAds = process.env.NODE_ENV === "development";
  const showAds =
    tier != null &&
    adsVisible &&
    !!adsProvider &&
    tier !== REGULAR_TIER &&
    tier !== UNLIMITED_TIER;

  const router = useRouter();

  const slotRef = useRef<any | null>(null);
  const playwireAdControllerRef = useRef<ReturnType<
    typeof createLobbyPlaywireAdController
  > | null>(null);
  if (playwireAdControllerRef.current === null) {
    playwireAdControllerRef.current = createLobbyPlaywireAdController();
  }

  useEffect(() => {
    // Use the reliable leaderboard until there is enough side space for the
    // temporary 300x600 Players unit. The product canvas stays centered in
    // both layouts.
    const wideRailMedia = window.matchMedia("(min-width: 1700px)");
    const desktopMedia = window.matchMedia("(min-width: 768px)");
    const update = () => {
      setAdLayout(getLobbyAdLayout(wideRailMedia.matches));
      setIsDesktop(desktopMedia.matches);
    };
    update();
    wideRailMedia.addEventListener("change", update);
    desktopMedia.addEventListener("change", update);
    return () => {
      wideRailMedia.removeEventListener("change", update);
      desktopMedia.removeEventListener("change", update);
    };
  }, []);

  // One-time initialization on mount
  useEffect(() => {
    router.prefetch("/game");
    initLobbyChosenGame(isDesktop, tab);
    window.scrollTo(0, 0);
    enterLobby();

    // Check if we need to show the chess set selection popup
    const { showPopup } = checkChessSetForUser();
    setShowChessSetPopup(showPopup);
  }, []);

  // Preload assets when settings are available
  useEffect(() => {
    if (chessSet) {
      preloadChessImages(chessSet);
    }
    if (isDesktop) {
      preloadStockfish();
    }
  }, [chessSet, isDesktop]);

  useEffect(() => {
    if (
      showDevelopmentAds ||
      !adsVisible ||
      adLayout === null ||
      tier == null ||
      tier === REGULAR_TIER ||
      tier === UNLIMITED_TIER
    ) {
      return;
    }

    let stopPlaywireAd: (() => void) | null = null;

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      stopPlaywireAd = playwireAdControllerRef.current.start(
        adLayout,
        shouldCountPlaywirePageview(),
      );
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(adLayout);
    } else if (adsProvider === ADS_PROVIDER_GAM) {
      initGAM(slotRef, adLayout);
    }

    return () => {
      stopPlaywireAd?.();
      if (!window.googletag?.cmd || !slotRef.current) return;

      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([slotRef.current]);
      });

      slotRef.current = null;
    };
  }, [adsVisible, adsProvider, tier, adLayout, isDesktop, showDevelopmentAds]);

  function renderSideAdRight() {
    if (showDevelopmentAds && adLayout) {
      return <DevelopmentAd adLayout={adLayout} />;
    }

    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return <div id="lobby_skyscraper_right" className={styles.sideAd} />;

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.sideAd}
            showRemoveAds={false}
            slot="3442544075"
            format="auto"
            insStyle={{ width: "100%" }}
          />
        );

      case ADS_PROVIDER_YANDEX:
        return (
          <div className={styles.sideAd} id="yandex_rtb_R-A-1674804-5"></div>
        );

      case ADS_PROVIDER_GAM:
        return (
          <div id={GAM_ID_DESKTOP} className={styles.sideAd}>
            {/* DIY ad slot - implement your ad solution here */}
          </div>
        );

      default:
        return null;
    }
  }

  function renderFooterAd() {
    if (showDevelopmentAds && adLayout) {
      return <DevelopmentAd adLayout={adLayout} />;
    }

    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return <PlayWire id="lobby_bottom" className={styles.footerAd} />;

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.footerAd}
            showRemoveAds={false}
            slot="6991788029"
            format="auto"
            insStyle={{ width: "100%", height: "120px" }}
          />
        );
      case ADS_PROVIDER_YANDEX:
        return (
          <div className={styles.footerAd} id="yandex_rtb_R-A-1674804-9"></div>
        );

      case ADS_PROVIDER_GAM:
        return (
          <div className={styles.footerAd} id={GAM_ID_MOBILE}>
            {/* DIY ad slot - implement your ad solution here */}
          </div>
        );

      default:
        return <div className={styles.footerAd}></div>;
    }
  }

  const reserveMobileAdSpace =
    isDesktop !== true &&
    (showDevelopmentAds || (tier !== REGULAR_TIER && tier !== UNLIMITED_TIER));
  const mobileBottomAd = reserveMobileAdSpace ? (
    <div className={styles.mobileAdArea}>
      <div className={styles.mobileAdCanvas}>
        {(showAds || showDevelopmentAds) && adLayout === "bottom"
          ? renderFooterAd()
          : null}
      </div>
    </div>
  ) : null;

  return (
    <>
      <Head>
        <title>{`Chess Hotel | ${t("Play")}`}</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      {customGamePopupVisible && <CustomGamePopup />}
      {challengePopupVisible && (
        <ChallengePopup
          onClose={() => showChallengePopup(false)}
          friend={null}
        />
      )}
      {showChessSetPopup && (
        <ChessSetPopup onClose={() => setShowChessSetPopup(false)} />
      )}
      <LobbyPopups />
      <main className={styles.workspace}>
        <div className={styles.canvasHost}>
          <div className={styles.productCanvas}>
            <LobbyHead />
            <div className={styles.columns}>
              <div
                className={`${styles.invitesColumn} flex min-w-0 flex-1 flex-col md:block`}
              >
                <LobbyBody
                  isDesktop={isDesktop}
                  compactMobile
                  mobileAd={mobileBottomAd}
                />
              </div>
              <div
                className={`${styles.createColumn} relative hidden min-w-0 flex-col md:flex`}
              >
                <CreateGame isDesktop={isDesktop} />
              </div>
            </div>
          </div>
        </div>
        {(showAds || showDevelopmentAds) && hasLobbySideAd(adLayout) && (
          <aside key={adLayout} className={styles.adRail}>
            {renderSideAdRight()}
          </aside>
        )}
      </main>
      {(showAds || showDevelopmentAds) &&
        adLayout === "bottom" &&
        isDesktop === true && (
          <div className={styles.bottomAdArea}>
            <div className={styles.bottomAdCanvas}>{renderFooterAd()}</div>
          </div>
        )}
      {/* Force CSS background image loading - uses inline styles to match Piece.tsx */}
      <div
        style={{
          position: "absolute",
          visibility: "hidden",
          width: 0,
          height: 0,
          overflow: "hidden",
        }}
      >
        {/* Preload board background */}
        <div className={boardStyles[chessSet]}></div>
        {/* Preload all piece images using inline styles (matches Piece.tsx) */}
        {getPieceImageUrls(chessSet).map((url) => (
          <div
            key={url}
            style={{
              width: 1,
              height: 1,
              backgroundImage: `url(${url})`,
              backgroundSize: "contain",
            }}
          />
        ))}
      </div>
    </>
  );
}
